// Code review - In Progress
// Documentation - In Progress
import React from "react";
import pdf from "../image/Assessment_Report_HP_2024-2025.pdf";

const ViewPopup = () => {
  return (
    <div className="h-60 flex items-center justify-center">
      <a href={pdf} target="_blank" rel="noopener noreferrer" className="text-center">
        <p className="text-blue-600 underline">View PDF</p>
      </a>
    </div>
  );
};

export default ViewPopup;

